<template>
    <widget-card>
        <template #header>
            <QrCode class="widget-icon" />
            <span class="widget-card-header__title">{{ trans('dashboard.v2.asset_type_distribution.title') }}</span>
        </template>
        <div v-if="loading" class="d-flex flex-wrap gap-2">
            <SkeletonLoader class="distribution-card" v-for="i in 2" :key="i">
                <div class="circle-graph">
                    <div style="width: 60px; height: 60px; border-radius: 50%"></div>
                </div>
                <div class="type-label-skeleton"></div>
            </SkeletonLoader>
        </div>

        <empty-widget-state
            v-else-if="!distribution || distribution.length === 0"
            :text="trans('dashboard.v2.asset_type_distribution.empty_state.description')"
        />
        <div v-else class="d-flex flex-wrap gap-2">
            <div v-for="item in distribution" :key="item.type" class="distribution-card">
                <DoughnutChartCard :values="[item.inoperable, item.operable]" :center-label="item.inoperable" :label="item.label" />
            </div>
        </div>
    </widget-card>
</template>

<script setup>
import WidgetCard from '@/Pages/DashboardV2/Components/WidgetCard.vue';
import QrCode from '../../../../icons/QrCode.vue';
import SkeletonLoader from '@/Components/SkeletonLoader.vue';
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { eventBus, events } from '@/eventBus';
import DoughnutChartCard from '@/Components/Charts/DoughnutChartCard.vue';
import EmptyWidgetState from '@/Pages/DashboardV2/Components/EmptyWidgetState.vue';
import { $http } from '@/bootstrap';

const props = defineProps({
    widgetData: {
        type: Object,
        required: true,
        default: () => ({}),
    },
});

const dataUrl = computed(() => props.widgetData.dataUrl);

const loading = ref(true);
const distribution = ref([]);

const fetchData = async (showLoading = false) => {
    try {
        loading.value = showLoading;
        const response = await $http.get(dataUrl.value);
        distribution.value = response.data.distribution;
    } catch (error) {
        distribution.value = [];
        console.error('Failed to fetch asset type distribution:', error);
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    fetchData(true);
    eventBus.$on(events.dashboardWidgetRefresh, fetchData);
});

onBeforeUnmount(() => {
    eventBus.$off(events.dashboardWidgetRefresh, fetchData);
});
</script>

<style scoped>
:deep(.skeleton-loader) {
    background: #f5f7fa;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    text-align: center;
}

.chart-wrapper {
    display: inline-block;
}
</style>
